import { render, staticRenderFns } from "./uploadfp.vue?vue&type=template&id=eb542bca&scoped=true&"
import script from "./uploadfp.vue?vue&type=script&lang=js&"
export * from "./uploadfp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb542bca",
  null
  
)

export default component.exports